import { useQuery } from "react-query";
import { getNotifications } from "../../api/notifications";
import { useMemo } from "react";

export const useGetNotifications = () => {
  const { data: result, refetch, isFetching, isRefetching } = useQuery('get-notifications', () => getNotifications());

  const formattedResult = useMemo(
    () => ({
      ...result,
      refetch,
      isFetching,
      isRefetching,
      notifications: result?.data?.['hydra:member'] || [],
    }),
    [result, refetch, isFetching, isRefetching]
  );

  return formattedResult;
}